import API from '../utils/api';
import { EVENT_CREATION_SERVICE_ENDPOINT_URL } from '../constants/defaultValues';

const getMarketGroups = async params => {
    try {
        const res = await API.get(`${EVENT_CREATION_SERVICE_ENDPOINT_URL}/market/groups`, {
            params,
        });

        return res.data;
    } catch (error) {
        console.error(error);
    }
};

const MarketGroupService = {
    getMarketGroups,
};

export default MarketGroupService;
